@if (!currency) {
  <input type="number" nbInput [formControl]="lowerfield" [step]="step" [min]="range.gte" [max]="range.lte">
}
@if (currency) {
  <input nbInput currencyMask [formControl]="lowerfield" [options]="Globals.currency" maxlength="7" [placeholder]="'enternumber' | translate" class="currency">
}
<div class="multi-range">
  <input type="range" [formControl]="lower" [step]="step" [min]="range.gte" [max]="range.lte">
  <input type="range" [formControl]="upper" [step]="step" [min]="range.gte" [max]="range.lte">
  <div class="center-fill" [style.left]="left" [style.width]="width"></div>
</div>
@if (!currency) {
  <input type="number" nbInput [formControl]="upperfield" [step]="step" [min]="range.gte" [max]="range.lte">
}
@if (currency) {
  <input nbInput currencyMask [formControl]="upperfield" [options]="Globals.currency" maxlength="7" [placeholder]="'enternumber' | translate" class="currency">
}
